export default class Util {
    public static str2Buffer(str: string) {
        return (new Uint8Array([].map.call(str, function(c: any) {
            return c.charCodeAt(0)
        }))).buffer;
    }

    public static getDevice() {
        const userAgent = window.navigator.userAgent.toLowerCase();

        let device: string;
        if (userAgent.indexOf('ipad') != -1) {
            device = 'ipad';
        }else if(userAgent.indexOf('iphone') != -1){
            device = 'iphone';
        }else if(userAgent.indexOf('android') != -1){
            device = 'android';
        }else{
            // 当てはまらなかったのでPCに割り振り
            device = 'pc';
        }

        return device;
    }

    public static isSafari() {
        const ua = navigator.userAgent.toLowerCase();
        return (
            ua.indexOf('chrome') == -1
            && ua.indexOf('msie') == -1
            && ua.indexOf('trident') == -1
            && ua.indexOf('edge') == -1
            && ua.indexOf('firefox') == -1
        );
    }
}
